import { render, staticRenderFns } from "./SubmitFeedbackModal.vue?vue&type=template&id=b90bd4d2&"
import script from "./SubmitFeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./SubmitFeedbackModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b90bd4d2')) {
      api.createRecord('b90bd4d2', component.options)
    } else {
      api.reload('b90bd4d2', component.options)
    }
    module.hot.accept("./SubmitFeedbackModal.vue?vue&type=template&id=b90bd4d2&", function () {
      api.rerender('b90bd4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/feedback/SubmitFeedbackModal.vue"
export default component.exports